import { LocationResponse } from 'containers/ServicesPage/types';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';

export interface FormValues {
  research: string;
  universe: string;
  filterWith: string;
  city: {
    lat?: number;
    lon?: number;
    name?: string;
  };
}

export const isWithingRange = (
  locationLat: number,
  locationLng: number,
  referenceLat: number,
  referenceLng: number,
  range: number,
): boolean =>
  Math.abs(locationLat - referenceLat) <= range &&
  Math.abs(locationLng - referenceLng) <= range;

export const filterLocationByRaisonSociale = (
  locations: LocationResponse[],
  filtre: string,
): LocationResponse[] => {
  return locations.filter((location: any) =>
    location.raison_sociale.toLowerCase().includes(filtre.toLowerCase()),
  );
};

export const handleSubmit = (values: FormValues, { props }: any) => {
  const {
    city: { lat, lon },
  } = values;
  GATracking.event(EVENT_CATEGORIES.SERVICES, EVENT_ACTION.CLICK, 'Rechercher');
  props.setCenter({ lat: values.city.lat!, lng: values.city.lon! });
  props.setFilter({ ...values, latitude: lat, longitude: lon });
  if (values.filterWith === 'directory_of_doctors') {
    props.getDoctors({
      research: values.research,
      latitude: lat,
      longitude: lon,
    });
    return;
  }
  props.getLocations({
    filterWith: values.filterWith,
    research: values.research,
    latitude: lat,
    longitude: lon,
  });
};
